<template>
  <section class="auth-page">
    <div class="content">
      <div class="title-box">
        <h2>Reddit数据分析系统</h2>
      </div>
      <div class="text">
        {{ loginLoading ? '认证中~' : '认证失效，请重新认证~' }}
      </div>
      <el-button
        class="login-btn"
        @click.native.prevent="handleLogin"
        :loading="loginLoading"
      >
        认 证
      </el-button>
    </div>
  </section>
</template>
<script>
import { oauthLoginApi, authUrlApi } from '@/api/oauth'
export default {
  data() {
    return {
      loginLoading: false
    }
  },
  async created() {
    localStorage.setItem('origin', this.$route.path)
    const { code, idToken } = this.getHash()
    if (code && idToken) {
      this.loginFun(code, idToken)
    }
    if (this.$route.query.autoLogin == 'true') {
      const urlResponce = await this.getUrl()
      if (urlResponce) {
        window.location.href = urlResponce
      }
    }
  },
  methods: {
    async handleLogin() {
      const urlResponce = await this.getUrl()
      if (urlResponce) {
        window.location.href = urlResponce
      }
    },
    // 登录
    async loginFun(code, idToken) {
      try {
        this.loginLoading = true
        const res = await oauthLoginApi({
          code: code,
          idToken: idToken,
          providerName: this.getProviderName()
        })
        window.localStorage.setItem('roles', res.roles)
        sessionStorage.setItem('userInfo', JSON.stringify(res))
        this.$store.commit('user/SET_INFO')
        this.$router.push('/')
      } catch (e) {
        this.loginLoading = false
      }
    },
    //获取登录地址
    async getUrl() {
      try {
        const res = await authUrlApi(this.getProviderName())
        return res
      } catch {
        return ''
      }
    },
    // 获取认证后的url信息
    getHash() {
      const query = new URLSearchParams(this.$route.hash.slice(1))
      const code = query.get('code') || null
      const idToken = query.get('id_token') || null
      return {
        code: code,
        idToken: idToken
      }
    },
    // 获取平台名称
    getProviderName() {
      let name = this.$route.params.platformName
      return name || ''
    }
  }
}
</script>
<style lang="scss" scoped>
$bg: #456da2;

.auth-page {
  --theme-color: #f74300;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url('../assets/loginImages/bg.jpg') no-repeat;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .content {
    width: 400px;
    height: 350px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 0 10px 10px #cfcfcf;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    padding-bottom: 40px;
    box-sizing: border-box;

    .title-box {
      background: var(--theme-color);
      width: 100%;
      text-align: center;
      padding: 20px;
      min-height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      box-sizing: border-box;

      h2 {
        margin: 0;
        color: #fff;
        font-size: 28px;
        line-height: 40px;
      }

      .old {
        margin: 0;
        color: #cfcfcf;
        font-size: 16px;
        line-height: 20px;
      }
    }

    .text {
      color: #9b9c9c;
      font-size: 16px;
    }

    .login-btn {
      background: var(--theme-color);
      border: 1px solid var(--theme-color);
      color: #fff;
      font-size: 16px;
      letter-spacing: 2px;
      width: 70%;
      height: 42px;
    }
  }
}
</style>
